import { forwardRef, useImperativeHandle, useRef } from 'react'
import BaseModal from '@/component/modal/BaseModal.tsx'
import SolidButton from '@/component/button/SolidButton.tsx'
import { useTranslation } from 'react-i18next'

export interface ISalesModalRef {
    show: () => void
    close: () => void
}

const SalesModal = forwardRef<ISalesModalRef>((_props, ref) => {
    const { t } = useTranslation()
    const modalRef = useRef<any>(null)

    useImperativeHandle(ref, () => ({
        show: () => modalRef.current?.show(),
        close: () => modalRef.current?.close()
    }))

    return (
        <BaseModal
            ref={modalRef}
            title={t('sales.modal.title')}
            width={'400'}
        >
            <div className={'flex flex-col gap-[20px] p-[20px]'}>
                <div className={'text-center whitespace-pre-wrap'}>
                    {t('sales.modal.desc')}
                </div>
                <div className={'flex flex-col gap-[10px]'}>
                    <div className={'flex justify-between items-center bg-gray-100 p-[10px] rounded-[8px]'}>
                        <span className={'font-bold'}>{t('sales.modal.phone')}</span>
                        <a href={`tel:${t('sales.modal.phone_number')}`} className={'text-blue-500 font-bold'}>
                            {t('sales.modal.phone_number')}
                        </a>
                    </div>
                    <div className={'flex justify-between items-center bg-gray-100 p-[10px] rounded-[8px]'}>
                        <span className={'font-bold'}>{t('sales.modal.email')}</span>
                        <a href={`mailto:${t('sales.modal.email_address')}`} className={'text-blue-500 font-bold'}>
                            {t('sales.modal.email_address')}
                        </a>
                    </div>
                </div>
                <SolidButton
                    text={t('common.close')}
                    onClick={() => modalRef.current?.close()}
                />
            </div>
        </BaseModal>
    )
})

export default SalesModal
